<div id="bus_pol_model" class="know-more-sections">
    <div class="km-close-btn" (click)="Close()">
        <span class="clicktoclose"><i class="icon-k-close"></i></span>
    </div>

    <div class="km-gia-rang no-select">
        <div class="container">
            <div class="row">
                
                <div class="gr-content-row bt-0" style="padding-top: 0;">
                    <div class="grc-txt-p">
                        <h1><b>Request {{ModalData}}</b></h1>
                    </div>
                </div>

                <ng-container *ngIf="ShowOTPForm == false">
                    <h6>Company name *</h6>
                    <input type="text" placeholder="Company Name *" [(ngModel)]="COMP_NAME">
    
    
                    <h6>First name *</h6>
                    <input type="text" placeholder="First Name *" [(ngModel)]="F_NAME">
    
                    <h6>Last name</h6>
                    <input type="text" placeholder="Last Name" [(ngModel)]="L_NAME">
    
                    <h6>Mob. Number *</h6>
                    <input type="text" placeholder="Mob. Number *" [(ngModel)]="COMP_NUMBER"> 
    
    
    
                    <h6>Mail *</h6>
                    <input type="text" placeholder="Mail *" [(ngModel)]="EMAIL_ID">
    
                    <button type="button" (click)="SubmitDetails()">Submit</button>
    
    
                </ng-container>

                <ng-container *ngIf="ShowOTPForm == true">
                    <h6>OTP</h6>
                    <input type="text" placeholder="OTP" [(ngModel)]="OTP">
                    
                    <button type="button" (click)="VerifyOTP()">Verify OTP</button>


                </ng-container>
             


                

            </div>
        </div>
    </div>
</div>

<div id="cover" [@ShowHide]="loaderspinning ? 'spinning' : 'stopped'">
    <img src="https://pcknstg.blob.core.windows.net/hdfile/webimg/logo_spin.png" class="img_spin">
</div>
